import * as m from "motion/react-m";

export const Center = ({ className }: { className?: string }) => {
  return (
    <m.svg
      animate={{ opacity: 1 }}
      className={className}
      fill='none'
      id='center'
      initial={{ opacity: 0 }}
      viewBox='0 0 475 322'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M73.0818 1C125.998 0.99819 231.683 152.858 237.196 160.767H237.521C237.521 160.767 237.466 160.845 237.358 161C237.466 161.155 237.521 161.233 237.521 161.233C237.521 161.233 237.412 161.233 237.196 161.233C231.683 169.142 125.998 321.002 73.0818 321C24.7037 320.998 1.00203 241 1.00203 161.233L1.00101 161C1.00096 160.923 1 160.844 1 160.767C1 77.5217 24.7037 1.00196 73.0818 1Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeOpacity='0.28'
      />
      <path
        d='M402.282 1C349.365 0.99819 243.68 152.858 238.167 160.767H237.842C237.842 160.767 237.897 160.845 238.005 161C237.897 161.155 237.842 161.233 237.842 161.233C237.842 161.233 237.952 161.233 238.167 161.233C243.68 169.142 349.365 321.002 402.282 321C450.66 320.998 474.361 241 474.361 161.233L474.362 161C474.362 160.923 474.363 160.844 474.363 160.767C474.363 77.5217 450.66 1.00196 402.282 1Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeOpacity='0.28'
      />
    </m.svg>
  );
};

export const CenterFilled = ({ className }: { className?: string }) => {
  return (
    <m.svg
      animate={{ opacity: 1 }}
      className={className}
      fill='none'
      id='center-filled'
      initial={{ opacity: 0 }}
      viewBox='0 0 475 322'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M73.1111 1C126.027 0.99819 231.712 152.858 237.226 160.767H237.551C237.551 160.767 237.495 160.845 237.388 161C237.495 161.155 237.551 161.233 237.551 161.233C237.551 161.233 237.441 161.233 237.226 161.233C231.712 169.142 126.027 321.002 73.1111 321C24.733 320.998 1.03132 241 1.03132 161.233L1.03031 161C1.03025 160.923 1.0293 160.844 1.0293 160.767C1.0293 77.5217 24.733 1.00196 73.1111 1Z'
        fill='#F0EDEA'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M402.311 1C349.395 0.99819 243.709 152.858 238.196 160.767H237.871C237.871 160.767 237.927 160.845 238.034 161C237.927 161.155 237.871 161.233 237.871 161.233C237.871 161.233 237.981 161.233 238.196 161.233C243.709 169.142 349.395 321.002 402.311 321C450.689 320.998 474.391 241 474.391 161.233L474.392 161C474.392 160.923 474.393 160.844 474.393 160.767C474.393 77.5217 450.689 1.00196 402.311 1Z'
        fill='#F0EDEA'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.5 16.5581C117.277 55.482 230.756 154.424 237.085 160.767H237.55C237.55 160.767 237.471 160.845 237.317 161C237.471 161.155 237.55 161.233 237.55 161.233C237.55 161.233 237.393 161.233 237.085 161.233C230.756 167.577 117.277 266.518 39.5 305.442'
        opacity='0.28'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M237.366 160.767H237.551L237.458 161M125.666 29.5C111.261 59.2237 103.059 108.679 103.059 160.767C103.059 160.844 103.059 160.923 103.059 161L103.06 161.233C103.06 211.144 111.262 261.146 125.666 291.585'
        opacity='0.28'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M239.243 160.767H239.058L239.151 161M350.943 29.5C365.348 59.2237 373.551 108.679 373.551 160.767C373.551 160.844 373.55 160.923 373.55 161L373.55 161.233C373.55 211.144 365.348 261.146 350.943 291.585'
        opacity='0.28'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M435.551 16.5581C357.774 55.482 244.295 154.424 237.966 160.767H237.5C237.5 160.767 237.58 160.845 237.734 161C237.58 161.155 237.5 161.233 237.5 161.233C237.5 161.233 237.658 161.233 237.966 161.233C244.295 167.577 357.774 266.518 435.551 305.442'
        opacity='0.28'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </m.svg>
  );
};
